<template>
  <div class="p-b-5">
    <v-table
      :data="rttReferences"
      :current-page.sync="currentPage"
      :page-size="10"
      :hide-sort-icons="true"
      class="table_beauty"
      @totalPagesChanged="totalPages = $event"
    >
      <thead slot="head">
        <tr>
          <v-th
            :custom-sort="typeSort"
            default-sort="asc"
          >
            Type
          </v-th>
          <v-th sort-key="name">
            Name
          </v-th>
          <th v-t="'RTT_REFERENCES_TABLE_ID'">
            Id
          </th>
        </tr>
      </thead>
      <tbody
        slot="body"
        slot-scope="{ displayData }"
      >
        <tr
          v-for="row in displayData"
          :key="row.id"
        >
          <td>{{ row.type }}</td>
          <td>
            <a
              rel="noopener"
              target="_blank"
              :href="row.link"
              class="table-ellipsis__name linked-name"
            >
              <span :title="row.name">
                {{ row.name }}
              </span>
            </a>
          </td>
          <td>
            {{ row.id }}
          </td>
        </tr>
      </tbody>
    </v-table>
    <div
      class="pagination-min"
    >
      <div class="text-center p-7">
        <smart-pagination
          :current-page.sync="currentPage"
          :total-pages="totalPages"
        />
      </div>
    </div>
    
    <div
      v-if="getRingTreeTargetReferencesStatus.status === 'pending'"
      class="well well-sm text-center"
    >
      <Loader />
      <span v-t="'RTT_REFERENCES_LOADING'" />
    </div>
    <div
      v-if="getRingTreeTargetReferencesStatus.status === 'success' && rttReferences.length === 0"
      v-t="'RTT_REFERENCES_EMPTY'"
      class="well well-sm text-center"
    />
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import messages from '../locales';
import Loader from '@/core/components/Loader';
import { getStatus } from '@/store/helpers';
import { GET_RTT_REFERENCES } from '../store/actionTypes';

export default {
  name: 'RingTreeTargetReferences',
  components: {
    Loader,
  },
  props: {
    ringTreeTargetId: {
      type: String,
      default() {
        return '';
      },
    },
  },
  data: function () {
    return {
      currentPage: 1,
      totalPages: 0,
    };
  },
  computed: {
    ...mapState('ringTreeTargets', ['rttReferences', 'getRingTreeTargetReferencesStatus']),
    ...mapState('ringTreeTargets', {
      getRingTreeTargetReferencesStatus: (state) => getStatus(state, GET_RTT_REFERENCES) || {},
    }),
  },
  created() {
    this.getRingTreeTargetReferences(this.ringTreeTargetId);
  },
  methods: {
    ...mapActions('ringTreeTargets', [GET_RTT_REFERENCES]),
    typeSort(a, b) {
      if (a.type === b.type) {
        if (a.name === b.name) {
          return 0;
        }
        if (a.name > b.name) {
          return 1;
        }
        return -1;
      }
      if (a.type > b.type) {
        return 1;
      }
      return -1;
    },
  },
  i18n: {
    messages,
    locale: 'en',
  },
};
</script>

<style>

</style>